require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./careers-cloudthing-india-it-admin-role.json") })
        }
      }, "path---careers-cloudthing-india-it-admin-role");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---careers-cloudthing-india-it-admin-role!./.cache/json/careers-cloudthing-india-it-admin-role.json
// module id = 852
// module chunks = 231608221292675